import React, { Component } from 'react'
import SRCards from '../../components/SRCards'
import InvoiceApi from '../../services/invoice.service'
import {
    Button, Container, Paper, TableContainer, TextField, Table,
    TableHead, TableRow, TableCell, TableBody, TableFooter,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Typography
} from '@material-ui/core'
import { Alert } from '@material-ui/lab';

type IProps = {
    location: any
}
type IState = {
    invoices: any;
    dialog: any;
    confirmMsg: any;
    pageResponse: any;
    snackBar: any;
    searchValue:any;
    invoiceToBeDeleted: any;
}
const apiservices = new InvoiceApi();

class InvoiceList extends Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            invoices: [],
            dialog: false,
            confirmMsg: null,
            pageResponse: null,
            snackBar: '',
            searchValue:null,
            invoiceToBeDeleted: null
        };
    }

    async onSearch(e: any) {
        if (e.key === 'Enter') {
            const response = await apiservices.getInvoices(
                e.target.value
            );
            this.setState({
                invoices: response,
                searchValue:e.target.value
            })
        }
    }

    async confirm(invoiceId: any, invoiceNumber: any) {
        let res = `This operation will delete invoice - ${invoiceNumber} 
                    along with its invoice items.`
        this.setState({
            dialog: true,
            confirmMsg: res,
            invoiceToBeDeleted: invoiceId
        })
        return
    }

    async cancel() {
        this.setState({
            dialog: false,
            snackBar: 'info',
            pageResponse: `Deletion Cancelled.`
        })
    }

    async delete() {
        const { invoiceToBeDeleted, searchValue } = this.state;
        let response = await apiservices.deleteInvoice(invoiceToBeDeleted);
        if (response && response.id) {
            const updated = await apiservices.getInvoices(
                searchValue
            );
            this.setState({
                dialog: false,
                snackBar: 'success',
                pageResponse: "Deleted Successfully.",
                invoices: updated
            })
        }
        else {
            let msg;
            if(response && response.message && response.description) {
                msg = `Delete Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Delete Failed.`
            }
            this.setState({
                dialog: false,
                snackBar: 'error',
                pageResponse: msg
            })
        }
    }

    render() {
        return (
            <div>
                <SRCards />
                <Container>
                    <Typography
                        style={{
                            padding: 16
                        }}
                    >
                        {localStorage.getItem('selectedCompanyDisplay')}
                    </Typography>
                    <TextField
                        style={{ padding: 20 }}
                        variant="outlined"
                        onKeyDown={(e) => this.onSearch(e)}
                        placeholder='Search Invoice..' />
                    <TableContainer
                        component={Paper}
                        style={{
                            width:1500
                        }}
                    >
                        <Table
                            style={{
                                minWidth: 700,
                            }}
                            aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Action</TableCell>
                                    <TableCell>Invoice</TableCell>
                                    <TableCell>Invoice Date</TableCell>
                                    <TableCell>Customer Name</TableCell>
                                    <TableCell>Customer Location</TableCell>
                                    <TableCell>Job Type</TableCell>
                                    <TableCell>Estimated Hours</TableCell>
                                    <TableCell>Sub Total</TableCell>
                                    <TableCell>Tax</TableCell>
                                    <TableCell>Total</TableCell>
                                </TableRow>
                            </TableHead>
                            {this.state.invoices.length > 0 ?
                                this.state.invoices.map((invoice: any) => {
                                    return (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <Button
                                                        style={{ margin: 10 }}
                                                        variant='outlined'
                                                        onClick={this.confirm.bind(
                                                            this, 
                                                            invoice.id, 
                                                            invoice.invoiceNumber
                                                            )
                                                        }
                                                    >
                                                        Delete
                                                    </Button>
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.invoiceNumber}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.invoiceDate}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.serviceAddress.displayName}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.serviceAddress.addressLine1},
                                                    {invoice.serviceAddress.city},
                                                    {invoice.serviceAddress.state},
                                                    {invoice.serviceAddress.zipcode}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.jobType}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.estimatedHours}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.subTotal}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.tax}
                                                </TableCell>
                                                <TableCell>
                                                    {invoice.total}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                }) : null}
                            <TableFooter>
                                <TableRow>

                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                    <Dialog
                        open={this.state.dialog}
                        onClose={() => {
                            this.setState({
                                dialog: false
                            })
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            {'Confirmation!'}
                        </DialogTitle>
                        <DialogContent>
                            {this.state.confirmMsg}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={
                                    () => {
                                        this.setState({
                                            confirmMsg:'Processing...'
                                        })
                                        this.delete()
                                    }
                                }
                            >
                                Confirm
                                </Button>
                            <Button
                                onClick={
                                    () => this.cancel()
                                }
                                autoFocus
                            >
                                Cancel
                                </Button>
                        </DialogActions>
                    </Dialog>
                    <Snackbar
                        open={this.state.snackBar === '' ? false : true}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        autoHideDuration={6000}
                        onClose={() => {
                            this.setState({
                                snackBar: ''
                            })
                        }}
                    >
                        <Alert
                            severity={this.state.snackBar}
                            onClose={() => {
                                this.setState({
                                    snackBar: ''
                                })
                            }
                            }>
                            {this.state.pageResponse}
                        </Alert>
                    </Snackbar>
                </Container>
            </div>
        )
    }
}

export default InvoiceList;